import { createContext, useContext } from "react";

export const WorldCtx = createContext(null);
export const useWorld = () => useContext(WorldCtx);
